/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateFileDataScanStatusSchema = z.enum(['queued', 'scanning', 'clean', 'infected', 'error', 'skipped'])

export type CandidateFileDataScanStatusSchema = z.infer<typeof candidateFileDataScanStatusSchema>
